var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboardEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 464.686 464.686",
    style: {
      enableBackground: "new 0 0 464.686 464.686"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M76.531,464.686h311.625c4.487,0,8.129-3.642,8.129-8.129V50.69c0-4.487-3.642-8.129-8.129-8.129 h-43.114c-4.487,0-8.129,3.642-8.129,8.129s3.642,8.129,8.129,8.129h34.985v389.611H84.659V58.818h34.994 c4.487,0,8.129-3.642,8.129-8.129s-3.642-8.129-8.129-8.129H76.531c-4.487,0-8.129,3.642-8.129,8.129v405.868 C68.402,461.045,72.035,464.686,76.531,464.686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010002"
    },
    d: "M152.159,112.02h160.369c4.487,0,8.129-3.642,8.129-8.129V32.449c0-4.487-3.642-8.129-8.129-8.129 h-26.458V8.129c0-4.487-3.642-8.129-8.129-8.129h-91.203c-4.487,0-8.129,3.642-8.129,8.129v16.2h-26.45 c-4.487,0-8.129,3.642-8.129,8.129v71.442C144.03,108.378,147.672,112.02,152.159,112.02z M160.287,40.578h26.45 c4.487,0,8.129-3.642,8.129-8.129V16.257h74.954v16.2c0,4.487,3.642,8.129,8.129,8.129h26.45v55.185H160.287V40.578z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#010002"
    },
    cx: 232.339,
    cy: 48.942,
    r: 15.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardEmpty);
export default __webpack_public_path__ + "static/media/clipboard-empty.388cec536ea07d4e6f4960466f7d3de6.svg";
export { ForwardRef as ReactComponent };